import { getPageLinks as getCreatePageLinks } from '../utils/getPageLinks';
import { messages } from '../messages';
import { useGetContainerProps } from '../hooks/useGetContainerProps';
import { SurveyUpsertPage } from '../components/SurveyUpsertPage';

const getBreadcrumbLinks = () => getCreatePageLinks('New Survey');
const containerParams = { getBreadcrumbLinks };

export const SurveyCreatePageContainer = () => {
  const {
    layoutProps,
    configureFormProps,
    targetFormProps,
    scheduleFormProps,
    dialogProps,
    breadcrumbLinks,
  } = useGetContainerProps(containerParams);

  return (
    <SurveyUpsertPage
      layoutProps={layoutProps}
      dialogProps={dialogProps}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      configureFormProps={configureFormProps}
      targetFormProps={targetFormProps}
      scheduleFormProps={scheduleFormProps}
      breadcrumbLinks={breadcrumbLinks}
    />
  );
};
